define.alias("shared/utils/formatters/create-formatted-industry-hashtags", "media/utils/formatters/create-formatted-industry-hashtags");